import moment from "moment";

const moneyFormater = Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
});


export default {
    html (text) {
        if (!text) {
            return "";
        }

        return text.replaceAll("\n", "<br>");
    },

    today () {
        return moment () .format('DD.MM.YYYY')
    },


    delayInMonth (date) {
        const past = moment (date, "YYYY-MM-DD");
        const now = moment ();
        return now.diff (past, 'month');
    },

    delayInDays (date) {
        const past = moment (date, "YYYY-MM-DD");
        const now = moment ();
        return now.diff (past, 'day');
    },

    future (date) {
        return moment (date, "YYYY-MM-DD").diff (moment()) > 0
    },

    date: {
        display(value) {
            if (!value) {
                return "";
            }

            return moment (value) .format('DD.MM.YYYY')
        },

        sdisplay(value) {
            if (!value) {
                return "";
            }

            return moment (value) .format('DD.MM.YY')
        },

        toJson (value) {
            return moment(value, "DD.MM.YYYY").format ("YYYY-MM-DD");
        },

        today () {
            return moment().format ("YYYY-MM-DD");
        },

        before (months) {
            return moment().subtract(months, 'months').format('YYYY-MM-DD');
        }
    },

    time(value) {
        return moment (value) .format('HH:mm:ss')
    },

    shorttime(value) {
        return moment (value) .format('HH:mm')
    },

    datetime: {
        display(value) {
            if (!value) {
                return "";
            }

            return moment (value) .format('DD.MM.YYYY HH:mm')
        },

        toJson (value) {
            return moment(value, "DD.MM.YYYY HH:mm").format ("YYYY-MM-DDTHH:mm:ss");
        }
    },


    money (value) {
        if (!value || value === 0) {
            return "";
        }

        return moneyFormater.format(value);
    },
}